import { Injectable, Output, EventEmitter } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { IAssetStatus, ICopyDocumentReponse, IPlaceIneRegBinder, IRegDocSites } from "../models";
import { RoutingService, SecurityService } from "src/app/services";
import { AssetTracking } from "../models/document/assettracking";
import { StudyStatMetrics } from "src/app/models/studystat/metrics";
import { lastValueFrom } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private lookups = new Map<string, any>();
  private Document_URL = environment.triportDocumentService.url + environment.triportDocumentService.apiVersion;
  private eSafe_URL = environment.regDocService.url + environment.regDocService.apiVersion;
  private News_URL = environment.triportNewsService.url + environment.triportNewsService.apiVersion;
  UserBinderListLookupKey = "UserBinderList";

  constructor(private http: HttpClient, private routeService: RoutingService, private securityService: SecurityService) { }

  getSiteBinderList() {
    return new Promise<Array<IRegDocSites>>((resolve, reject) => {

      if (this.lookups.has(this.UserBinderListLookupKey)) {
        resolve(this.lookups.get(this.UserBinderListLookupKey));
      } else {
        this.http.get<Array<IRegDocSites>>(this.eSafe_URL + `Binder/GetUserBinderList/${this.securityService.currentUserValue.UserID}`)
          .toPromise()
          .then((binderList?: Array<IRegDocSites>) => {
            this.lookups.set(this.UserBinderListLookupKey, binderList);
            resolve(binderList!);
          },
            (err) => {
              reject(err);
            });
      }
    });
  }

  moveDocument(sponsorName: string, portalId: number, PlaceIneRegBinder: IPlaceIneRegBinder, mid: string) {
    return new Promise<ICopyDocumentReponse>((resolve, reject) => {
      this.http.post<ICopyDocumentReponse>(this.Document_URL + `Document/moveDocument/${sponsorName}/${portalId}/${mid}`, PlaceIneRegBinder)
        .toPromise()
        .then((response?: ICopyDocumentReponse) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }

  getDocumentUrl(sponsorName: string, portalId: number, mid: string) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(this.Document_URL + `Document/documentUrl/${sponsorName}/${portalId}/${mid}`)
        .toPromise()
        .then((response?: any) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }

  getDocumentLinkURLByAssetGUID(sponsorName: string, portalId: number, assetGuid: string) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(this.Document_URL + `Document/documentLink/${sponsorName}/${portalId}/${assetGuid}`)
        .toPromise()
        .then((response?: any) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }

  getCategoryList(sponsorName: string, portalId: number, groupName: string) {
    return new Promise<Array<any>>((resolve, reject) => {
      this.http.get<Array<any>>(this.Document_URL + `Document/categoryList/${sponsorName}/${portalId}/${groupName}`)
        .toPromise()
        .then((response?: Array<any>) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }
  getAssetsWithCategoryList(sponsorName: string, portalId: number, groupName: string, assetCategoryId: number) {
    return new Promise<Array<any>>((resolve, reject) => {
      this.http.get<Array<any>>(this.Document_URL + `Document/categoryList/${sponsorName}/${portalId}/${groupName}/${assetCategoryId}`)
        .toPromise()
        .then((response?: Array<any>) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }

  getDocumentList(sponsorName: string, portalId: number, groupName: string, sortOptions: any) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(this.Document_URL + `Document/list/${sponsorName}/${portalId}/${groupName}`, sortOptions)
        .toPromise()
        .then((response?: any) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }

  downloadFile(sponsorName: string, portalId: number, mid: string) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(this.Document_URL + `Document/download/${sponsorName}/${portalId}/${mid}`)
        .toPromise()
        .then((response?: any) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }
  getStatus(sponsorName: string, portalId: number, mid: string): Promise<IAssetStatus> {
    return new Promise<IAssetStatus>((resolve, reject) => {
      this.http.get<IAssetStatus>(this.Document_URL + `Document/Status/${sponsorName}/${portalId}/${mid}`)
        .toPromise()
        .then((documentResponse?: IAssetStatus) => {
          resolve(documentResponse!);
        }, (err) => {
          reject(err);
        });
    });
  }

  getStatusByAssetId(sponsorName: string, portalId: number, aid: number): Promise<IAssetStatus> {
    return new Promise<IAssetStatus>((resolve, reject) => {
      this.http.get<IAssetStatus>(this.Document_URL + `Document/StatusByAssetId/${sponsorName}/${portalId}/${aid}`)
        .toPromise()
        .then((documentResponse?: IAssetStatus) => {
          resolve(documentResponse!);
        }, (err) => {
          reject(err);
        });
    });
  }

  GetBulkSignatureAssetDetails(sponsorName: string, portalId: number,assetTypeGroupingName:string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(this.Document_URL + `Document/GetBulkSignatureAssetDetails/${sponsorName}/${portalId}/${assetTypeGroupingName}`)
        .toPromise()
        .then((documentResponse: any) => {
          resolve(documentResponse);
        }, (err) => {
          reject(err);
        });
    });
  }

  PostEpaSignature(sponsorName: string, portalId: number, PersonAssetGUID: any) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(this.Document_URL + `Document/PostEpaSignature/${sponsorName}/${portalId}`, JSON.stringify(PersonAssetGUID))
        .toPromise()
        .then((response?: any) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }

  PostBulkSignature(sponsorName: string, portalId: number, PersonAssetGUIDs: any[]) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(this.Document_URL + `Document/BulkSignature/${sponsorName}/${portalId}`, JSON.stringify(PersonAssetGUIDs))
        .toPromise()
        .then((response?: any) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }

  GetDocumentUploadURL(sponsorName: string, portalId: number, fileName: string) {
    
    let body =JSON.stringify(fileName);
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(this.News_URL + `News/GetFileUploadUrl/${sponsorName}/${portalId}/`, body)
        .toPromise()
        .then((response?: any) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }

  getDocumentType(sponsorName: string, portalId: number, mid: string) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(this.Document_URL + `Document/AssetTypeGrouping/${sponsorName}/${portalId}/${mid}`)
        .toPromise()
        .then((response?: any) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }

  getDocumentTypeByAssetId(sponsorName: string, portalId: number, aid: number) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(this.Document_URL + `Document/AssetTypeGroupingByAssetId/${sponsorName}/${portalId}/${aid}`)
        .toPromise()
        .then((response?: any) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }

  getCategoriesByGroup(sponsorName: string, portalId: number, groupName: string) {
    return new Promise<Array<any>>((resolve, reject) => {
      this.http.get<Array<any>>(this.Document_URL + `Document/categories/${sponsorName}/${portalId}/${groupName}`)
        .toPromise()
        .then((response?: Array<any>) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }
  getStudyResourcesWithCategoryList(sponsorName: string, portalId: number, groupName: string, assetCategoryId: number) {
    return new Promise<Array<any>>((resolve, reject) => {
      this.http.get<Array<any>>(this.Document_URL + `Document/studyresources/${sponsorName}/${portalId}/${groupName}/${assetCategoryId}`)
        .toPromise()
        .then((response?: Array<any>) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }
  insertAssetTracking(sponsorName: string, assetTracking: AssetTracking) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(this.Document_URL + `Document/tracking/${sponsorName}`, JSON.stringify(assetTracking))
        .toPromise()
        .then((response?: any) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }
  getStudyStatMetrics(sponsorName:string, portalId: number) {
    return new Promise<StudyStatMetrics>((resolve, reject) => {
      lastValueFrom(this.http.get(this.Document_URL + `Document/studystatmetrics/${sponsorName}/${portalId}`
      ))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  getPersonAssetGuid(sponsorName:string, portalId: number, assetId:number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.Document_URL + `Document/personasset/${sponsorName}/${portalId}/${assetId}`
      ))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  getDocumentUrlByAssetId(sponsorName: string, portalId: number, assetId: number) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(this.Document_URL + `Document/documentUrlByAssetID/${sponsorName}/${portalId}/${assetId}`)
        .toPromise()
        .then((response?: any) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }

  // ── Admin: Create Document ───────────────────────────────────────────────

  getAdminAssetTypes(sponsorName: string, portalId: number): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      lastValueFrom(this.http.get<any[]>(this.Document_URL + `Document/admin/assetTypes/${sponsorName}/${portalId}`))
        .then(response => resolve(response!), err => reject(err));
    });
  }

  getAdminCategories(sponsorName: string, portalId: number, assetTypeId: number): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      lastValueFrom(this.http.get<any[]>(this.Document_URL + `Document/admin/categories/${sponsorName}/${portalId}/${assetTypeId}`))
        .then(response => resolve(response!), err => reject(err));
    });
  }

  getAdminSubcategories(sponsorName: string, portalId: number, categoryId: number): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      lastValueFrom(this.http.get<any[]>(this.Document_URL + `Document/admin/subcategories/${sponsorName}/${portalId}/${categoryId}`))
        .then(response => resolve(response!), err => reject(err));
    });
  }

  checkAdminDocumentExists(sponsorName: string, portalId: number, categoryId: number, documentName: string): Promise<{ Exists: boolean }> {
    return new Promise<{ Exists: boolean }>((resolve, reject) => {
      lastValueFrom(this.http.get<{ Exists: boolean }>(
        this.Document_URL + `Document/admin/documentExists/${sponsorName}/${portalId}/${categoryId}/${encodeURIComponent(documentName)}`
      )).then(response => resolve(response!), err => reject(err));
    });
  }

  createAdminDocument(sponsorName: string, portalId: number, formData: FormData): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(this.Document_URL + `Document/admin/create/${sponsorName}/${portalId}`, formData))
        .then(response => resolve(response!), err => reject(err));
    });
  }

  getDocumentFilteringConsole(sponsorName: string, portalId: number, assignmentRequest: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(
        this.Document_URL + `Document/admin/filteringConsole/${sponsorName}/${portalId}`,
        assignmentRequest
      )).then(response => resolve(response!), err => reject(err));
    });
  }

  getDocumentFilteringConsoleChilds(sponsorName: string, categoryId: number, treeview: any): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      lastValueFrom(this.http.post<any[]>(
        this.Document_URL + `Document/admin/filteringConsoleChilds/${sponsorName}/${categoryId}`,
        treeview
      )).then(response => resolve(response!), err => reject(err));
    });
  }
  getFileAIInsights(sponsorName: string, assetId: number) {
        return new Promise<any>((resolve, reject) => {
            this.http.get<any>(this.Document_URL + `Document/${sponsorName}/${assetId}/FileAIAnalysis`)
                .toPromise()
                .then((response?: any) => {
                    resolve(response!);
                },
                    (err) => {
                        reject(err);
                    });
        });
  }
}
